import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import Localizer from "@Scripts/Common/Localizer";
import FormHelper from "@Scripts/Common/FormHelper";
import TextHelper from "@Scripts/Common/TextHelper";
import DataHelper, { DataHelperConfiguration } from "@Scripts/Common/DataHelper";

@Component({ name: "ModuleVoucherCouponList" })
export default class ModuleVoucherCouponList extends Vue {
    public localizer: any = Localizer;
    public isDataLoading: boolean = false;
    public mode: string = null;
    public isSearchVisible: boolean = false;
    public item: any = null;
    public validationErrors: any[] = [];
    public formControls: any[] = [];
    public formContext: any = null;
    public dataConfiguration: DataHelperConfiguration = { culture: (<any>window).App.userCulture };

    get navigationContext(): any {
        return this.$store.getters["navigationStore/navigationContext"]
    }

    get itemIdMaster(): any {
        return this.$store.getters["itemStore/itemIdMaster"];
    }

    get controls(): any {
        return this.$store.getters["moduleVoucherCouponListStore/controls"];
    }

    get coupons(): any {
        return this.$store.getters["moduleVoucherCouponListStore/coupons"]
    }

    get search(): any {
        return this.$store.getters["moduleVoucherCouponListStore/search"]
    }

    get pagination(): any {
        return this.$store.getters["moduleVoucherCouponListStore/pagination"]
    }

    @Watch("navigationContext") onPropertyChanged(value: any, oldValue: any) {
        this.getData();
    }

    @Watch("$route.query.id") onRouteIdChanged(value: string, oldValue: string) {
        this.getData();
    }

    public created() {
        this.getData();
    }

    public async getData() {
        this.formControls = [];
        this.mode = null;

        this.isDataLoading = true;

        await this.$store.dispatch("moduleVoucherCouponListStore/getData", { nav: this.navigationContext.nav });

        if (this.$route.query.id) {
            this.setItemDetail(<string>this.$route.query.id);
        } else {
            this.setItemList();
        }

        this.isDataLoading = false;
    }

    public setItemList() {
        this.mode = "ItemList";
        this.item = null;
        this.isSearchVisible = this.search.filters.some(x => x.value);
    }

    public setSearchVisible() {
        this.isSearchVisible = !this.isSearchVisible;
        if (!this.isSearchVisible) {
            this.resetSearch();
        }
    }

    public resetSearch() {
        this.isSearchVisible = false;

        this.updateSearch(this.search.filters.map(x => ({ name: x.name, value: null, secondValue: null })));
    }

    public async updateSearch(searchValues: any[]) {
        await this.$store.dispatch("moduleVoucherCouponListStore/setSearch", { searchValues: searchValues, nav: this.navigationContext.nav });

        this.getData();
    }

    public async setPageIndex(pageIndex: number) {
        await this.$store.dispatch("moduleVoucherCouponListStore/setPageIndex", { pageIndex: pageIndex, nav: this.navigationContext.nav });

        this.getData();
    }

    public async remove(id: string) {
        await this.$store.dispatch("moduleVoucherCouponListStore/removeCoupon", { nav: this.navigationContext.nav, id: id });

        this.getData();
    }

    public async openItemDetail(id: string) {
        if (!this.$route.query.id || <string>this.$route.query.id != id) {
            this.$router.push({ query: { nav: this.navigationContext.nav, id: id } });
        }
    }

    public async setItemDetail(id: string) {
        this.mode = "ItemDetail";
        this.validationErrors = [];
        this.item = null;

        if (id !== this.navigationContext.voidId) {
            this.item = (await this.$store.dispatch("moduleVoucherCouponListStore/getCoupon", { nav: this.navigationContext.nav, id: id })).data;
            if (!this.item) {
                this.$store.dispatch("toastStore/onAddToast", { message: this.localizer.get("DataWeb.Explorer.ItemNotFound"), type: "Warning" });
                this.$router.replace({ query: { nav: this.navigationContext.nav } });
            }
        }

        this.formControls = JSON.parse(JSON.stringify(this.controls));

        this.formContext = { navigationContext: this.navigationContext, nav: this.navigationContext.nav, itemId: id };

        if (this.item) {
            for (let control of this.formControls) {
                if (control.isDataField && this.item.hasOwnProperty(TextHelper.lowerCaseFirstLetter(control.name))) {
                    control.value = this.item[TextHelper.lowerCaseFirstLetter(control.name)];
                }
            }
        }
    }

    public async save() {
        this.validationErrors = [];
        let controlValues = [];

        for (let control of this.formControls) {
            if (control.isDataField) {
                controlValues.push({ name: control.name, value: control.value });
            }
        }

        try {
            await this.$store.dispatch("moduleVoucherCouponListStore/saveCoupon", { nav: this.navigationContext.nav, id: this.item ? this.item.id : this.navigationContext.voidId, controlValues: controlValues });

            this.$store.dispatch("toastStore/onAddToast", { message: !this.item ? this.localizer.get("DataWeb.Explorer.Message_ItemSaved") : this.localizer.get("DataWeb.Explorer.Message_ItemUpdated"), type: "Success" });

            this.$router.push({ query: { nav: this.navigationContext.nav } });
        } catch (error) {
            if (error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);

                for (let control of this.formControls) {
                    control.validationErrors = this.validationErrors.filter(x => x.name === control.name);
                }

                this.$store.dispatch("toastStore/onAddToast", { message: this.localizer.get("DataWeb.Explorer.Message_ValidationError"), type: "Warning" });
            }
        }
    }

    public convertToLocalDate(utcDate: string): string {
        return DataHelper.convertDateToString(utcDate, this.dataConfiguration);
    }

    public cancel() {
        this.$router.push({ query: { nav: this.navigationContext.nav } })
    }

    public getModuleData() {
        return { isCompleted: true, nav: this.navigationContext.nav };
    }
};